<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
import SecondarySideBarMenuVListItem from '@/components/items/SecondarySideBarMenuVListItem.vue';
import { smsChatTemplateList } from '@/constants/menuLists';

const emit = defineEmits<{
  'itemClick': [event: PointerEvent, message: string];
}>();

function handleItemClick(event: PointerEvent, message: string): void {
  emit('itemClick', event, message);
}
</script>

<template>
  <div
    :class="$style.smsChatTemplateAddVMenu"
    data-testid="smsChatTemplateAddVMenu"
  >
    <v-menu transition="slide-y-transition">
      <template #activator="{ props: menuProps }">
        <KBtn
          :class="$style.btn"
          size="xs"
          variant="text"
          append-icon="mdi-plus"
          v-bind="menuProps"
        >
          Template
        </KBtn>
      </template>
      <v-list density="compact">
        <template v-for="item in smsChatTemplateList" :key="item.title">
          <SecondarySideBarMenuVListItem
            @click="handleItemClick($event, item.title)"
          >
            {{ item.title }}
          </SecondarySideBarMenuVListItem>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smsChatTemplateAddVMenu {
  display: contents;

  :global {
    .v-list-item {
      color: colors.$color-text-primary;
    }
  }
}
.btn {
  text-transform: none;
}
</style>
